import { jsxs, jsx } from 'react/jsx-runtime';
import { I as Introduction } from './component-BQVkf--0.js';
import { L as LegalAgreements } from './component-Ds-j6V6r.js';
import { L as LinkList } from './component-Dpo3LgkY.js';
import { S as SocialMediaAppInfo } from './component-MD5aDeNm.js';
import { s as styleInject } from './style-inject.es-Bff-fD1R.js';

const footerItemList = [
    {
        title: 'Buy / Rent Cars',
        linkList: [
            {
                href: 'https://www.sgcarmart.com/new-cars',
                key: 'newCarsForSale',
                text: 'New Cars For Sale',
            },
            {
                href: 'https://www.sgcarmart.com/used-cars',
                key: 'usedCarsForSale',
                text: 'Used Cars For Sale',
            },
            {
                href: 'https://www.sgcarmart.com/car_rental/index.php',
                key: 'carsForRent',
                text: 'Cars For Rent',
            },
        ],
    },
    {
        title: 'Sell Your Car',
        linkList: [
            {
                href: 'https://www.sgcarmart.com/sell-car/post-an-ad',
                key: 'postAnAd',
                text: 'Post an Ad',
            },
            {
                href: 'https://www.sgcarmart.com/quotz/sell_by_bid.php?type=sbbid',
                key: 'sellByBidding',
                text: 'Sell by Bidding',
            },
            {
                href: 'https://www.sgcarmart.com/tools_tips/consignment.php',
                key: 'sellByConsignment',
                text: 'Sell by Consignment',
            },
        ],
    },
    {
        title: 'Aftermarket',
        linkList: [
            {
                href: 'https://www.sgcarmart.com/directory/index.php',
                key: 'workshopDirectory',
                text: 'Workshop Directory',
            },
            {
                href: 'https://www.sgcarmart.com/products/index.php',
                key: 'aftermarketProducts',
                text: 'Aftermarket Products',
            },
        ],
    },
    {
        title: 'Articles',
        linkList: [
            {
                href: 'https://www.sgcarmart.com/articles/car-reviews',
                key: 'carReviews',
                text: 'Car Reviews',
            },
            {
                href: 'https://www.sgcarmart.com/articles/advice',
                key: 'carAdvice',
                text: 'Car Advice',
            },
            {
                href: 'https://www.sgcarmart.com/articles/news',
                key: 'carNews',
                text: 'Car News',
            },
            {
                href: 'https://www.sgcarmart.com/articles/features',
                key: 'carFeatures',
                text: 'Car Features',
            },
            {
                href: 'https://www.sgcarmart.com/articles/videos',
                key: 'carVideos',
                text: 'Car Videos',
            },
        ],
    },
    {
        title: 'General',
        linkList: [
            {
                href: 'https://www.sgcarmart.com/about',
                key: 'aboutUs',
                text: 'About Us',
            },
            {
                href: 'https://www.sgcarmart.com/contact',
                key: 'contactUs',
                text: 'Contact Us',
            },
            {
                href: 'https://www.sgcarmart.com/careers',
                key: 'careers',
                text: 'Careers',
            },
            {
                href: 'https://www.sgcarmart.com/site-map',
                key: 'siteMap',
                text: 'Site Map',
            },
        ],
    },
    {
        title: 'Resources',
        linkList: [
            {
                href: 'https://www.sgcarmart.com/news/writeup.php?AID=70',
                key: 'coePrices',
                text: 'COE Prices',
            },
            {
                href: 'https://www.sgcarmart.com/services/calculator.php',
                key: 'carLoanCalculators',
                text: 'Car Loan Calculators',
            },
            {
                href: 'https://www.mycarforum.com',
                key: 'carForum',
                text: 'Car Forum',
            },
        ],
    },
    {
        title: '',
        linkList: [
            {
                href: 'https://www.sgcarmart.com/directory/insurance.php',
                key: 'carInsurance',
                text: 'Car Insurance',
            },
            {
                href: 'https://www.sgcarmart.com/quotz/free_valuation.php?type=fv',
                key: 'carValuation',
                text: 'Car Valuation',
            },
            {
                href: 'https://connect.sgcarmart.com/coe_renewal.php',
                key: 'coeRenewal',
                text: 'COE Renewal',
            },
        ],
    },
    {
        title: '',
        linkList: [
            {
                href: 'https://www.sgcarmart.com/warranty/index.php',
                key: 'usedCarWarranty',
                text: 'Used Car Warranty',
            },
            {
                href: 'https://www.sgcarmart.com/directory/carplate_index.php',
                key: 'biddedCarplates',
                text: 'Bidded Carplates',
            },
            {
                href: 'https://www.sgcarmart.com/news/carpark_index.php?TYP=carpark&LOC=all',
                key: 'carparkRates',
                text: 'Carpark Rates',
            },
        ],
    },
];

var css_248z = ".SGCM_UIKIT_NEXT_Desktop_containerRoot_7kh6q_1 {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.SGCM_UIKIT_NEXT_Desktop_containerNav_7kh6q_7 {\n  display: flex;\n  justify-content: center;\n  background-color: whitesmoke;\n}\n\n.SGCM_UIKIT_NEXT_Desktop_containerNavLinks_7kh6q_13 {\n  display: grid;\n  width: 970px;\n  justify-content: space-between;\n  padding: 40px 0 85px;\n  gap: 44px 0;\n  grid-template-columns: repeat(5, 1fr);\n  grid-template-rows: repeat(2, auto);\n}\n\n.SGCM_UIKIT_NEXT_Desktop_containerSocialMediaAppInfo_7kh6q_23 {\n  grid-column: 4/6;\n}\n\n.SGCM_UIKIT_NEXT_Desktop_containerIntroLegalAgreements_7kh6q_27 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 0 7px;\n  row-gap: 23px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQWE7RUFDYixzQkFBc0I7RUFDdEIsb0JBQW9CO0FBQ3RCOztBQUVBO0VBQ0UsYUFBYTtFQUNiLHVCQUF1QjtFQUN2Qiw0QkFBNEI7QUFDOUI7O0FBRUE7RUFDRSxhQUFhO0VBQ2IsWUFBWTtFQUNaLDhCQUE4QjtFQUM5QixvQkFBb0I7RUFDcEIsV0FBVztFQUNYLHFDQUFxQztFQUNyQyxtQ0FBbUM7QUFDckM7O0FBRUE7RUFDRSxnQkFBZ0I7QUFDbEI7O0FBRUE7RUFDRSxhQUFhO0VBQ2Isc0JBQXNCO0VBQ3RCLG1CQUFtQjtFQUNuQixtQkFBbUI7RUFDbkIsYUFBYTtBQUNmIiwiZmlsZSI6InN0eWxlcy5tb2R1bGUuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5jb250YWluZXJSb290IHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgYWxpZ24taXRlbXM6IHN0cmV0Y2g7XG59XG5cbi5jb250YWluZXJOYXYge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgYmFja2dyb3VuZC1jb2xvcjogd2hpdGVzbW9rZTtcbn1cblxuLmNvbnRhaW5lck5hdkxpbmtzIHtcbiAgZGlzcGxheTogZ3JpZDtcbiAgd2lkdGg6IDk3MHB4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gIHBhZGRpbmc6IDQwcHggMCA4NXB4O1xuICBnYXA6IDQ0cHggMDtcbiAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiByZXBlYXQoNSwgMWZyKTtcbiAgZ3JpZC10ZW1wbGF0ZS1yb3dzOiByZXBlYXQoMiwgYXV0byk7XG59XG5cbi5jb250YWluZXJTb2NpYWxNZWRpYUFwcEluZm8ge1xuICBncmlkLWNvbHVtbjogNC82O1xufVxuXG4uY29udGFpbmVySW50cm9MZWdhbEFncmVlbWVudHMge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBwYWRkaW5nOiAyMHB4IDAgN3B4O1xuICByb3ctZ2FwOiAyM3B4O1xufSJdfQ== */";
var styles = {"containerRoot":"SGCM_UIKIT_NEXT_Desktop_containerRoot_7kh6q_1","containerNav":"SGCM_UIKIT_NEXT_Desktop_containerNav_7kh6q_7","containerNavLinks":"SGCM_UIKIT_NEXT_Desktop_containerNavLinks_7kh6q_13","containerSocialMediaAppInfo":"SGCM_UIKIT_NEXT_Desktop_containerSocialMediaAppInfo_7kh6q_23","containerIntroLegalAgreements":"SGCM_UIKIT_NEXT_Desktop_containerIntroLegalAgreements_7kh6q_27"};
styleInject(css_248z);

const PageFooter = () => {
    const linkListDataWithKey = footerItemList.map((item, idx) => ({
        ...item,
        key: item.title || `link-list-${idx}`,
    }));
    return (jsxs("div", { className: styles.containerRoot, children: [jsx("div", { className: styles.containerNav, children: jsxs("nav", { className: styles.containerNavLinks, children: [linkListDataWithKey.map(({ key, title, linkList }) => (jsx(LinkList, { linkList: linkList, title: title }, key))), jsx("div", { className: styles.containerSocialMediaAppInfo, children: jsx(SocialMediaAppInfo, {}) })] }) }), jsxs("div", { className: styles.containerIntroLegalAgreements, children: [jsx(Introduction, {}), jsx(LegalAgreements, {})] })] }));
};

export { PageFooter as P };
//# sourceMappingURL=component-C2atWLD1.js.map
